/* ============================================================================
   MODO SIN CONEXION — Portal Kennedy
   ---------------------------------------------------------------------------
   Tres cosas:
     1. Registra el Service Worker (sw-kennedy.js), que guarda el portal.
     2. Guarda en el dispositivo lo que se va consultando: catalogo, clientes
        y sus saldos. No se descarga todo por adelantado; se llena con el uso.
     3. Cola de pedidos: si no hay red al enviar, se guarda y sale solo al
        reconectar.

   Aviso sobre el iPad: Safari borra estos datos si la app pasa 7 dias sin
   usarse. Con uso diario no es problema; si un vendedor la abre cada dos
   semanas, tendra que conectarse una vez para recuperarlos.
============================================================================ */

var KCC_DB = null, KCC_ONLINE = navigator.onLine;

/* ── Ninguna llamada puede quedarse colgada ────────────────────────────────
   Sin señal, fetch puede tardar minutos en rendirse (o no rendirse nunca), y
   la pantalla se queda en "Cargando..." para siempre. Se le pone un limite a
   TODAS las llamadas: 20 s con red, 3 s sin ella. Asi, en el peor caso, sale
   un error claro en vez de una espera infinita.                            */
(function(){
  if(window._KCC_FETCH) return;
  var original = window.fetch.bind(window);
  window._KCC_FETCH = original;
  window.fetch = function(entrada, opciones){
    opciones = opciones || {};
    // Si quien llama ya puso su propia señal de cancelacion, se respeta.
    if(opciones.signal) return original(entrada, opciones);
    // Las subidas de archivos no llevan limite: una foto grande con conexion
    // lenta puede tardar mas de 20 s, y abortarla la daba por fallida.
    var _m = String((opciones.method||'GET')).toUpperCase();
    var _sube = (_m==='PUT') ||
                (_m==='POST' && /\/storage\/v1\/object\//.test(String(entrada)));
    if(_sube && navigator.onLine) return original(entrada, opciones);

    var ctrl = new AbortController();
    var ms = navigator.onLine ? 20000 : 3000;
    var t = setTimeout(function(){ ctrl.abort(); }, ms);
    return original(entrada, Object.assign({}, opciones, {signal: ctrl.signal}))
      .catch(function(err){
        // Sin red, el fallo es esperado: no tiene sentido llenar la consola de
        // rojo ni asustar a nadie. Se devuelve una respuesta vacia y quien
        // llamo decide que mostrar.
        if(!navigator.onLine){
          return new Response('[]', {
            status: 200,
            headers: {'Content-Type':'application/json', 'x-kcc-sin-red':'1'}
          });
        }
        throw err;
      })
      .finally(function(){ clearTimeout(t); });
  };
})();

// ── Base local ────────────────────────────────────────────────────────────
function kccAbrirDB(){
  if(KCC_DB) return Promise.resolve(KCC_DB);
  return new Promise(function(res, rej){
    var r = indexedDB.open('kennedy-offline', 1);
    r.onupgradeneeded = function(e){
      var db = e.target.result;
      // 'datos'   -> respuestas de consultas, por clave
      // 'cola'    -> pedidos pendientes de enviar
      if(!db.objectStoreNames.contains('datos')) db.createObjectStore('datos', {keyPath:'k'});
      if(!db.objectStoreNames.contains('cola'))  db.createObjectStore('cola',  {keyPath:'id', autoIncrement:true});
    };
    r.onsuccess = function(e){ KCC_DB = e.target.result; res(KCC_DB); };
    r.onerror   = function(){ rej(r.error); };
  });
}

function kccGuardar(clave, valor){
  return kccAbrirDB().then(function(db){
    return new Promise(function(res){
      var t = db.transaction('datos','readwrite');
      t.objectStore('datos').put({k:clave, v:valor, t:Date.now()});
      t.oncomplete = function(){ res(true); };
      t.onerror    = function(){ res(false); };
    });
  }).catch(function(){ return false; });
}

function kccLeer(clave){
  return kccAbrirDB().then(function(db){
    return new Promise(function(res){
      var t = db.transaction('datos','readonly');
      var q = t.objectStore('datos').get(clave);
      q.onsuccess = function(){ res(q.result || null); };
      q.onerror   = function(){ res(null); };
    });
  }).catch(function(){ return null; });
}

// ── Cola de pedidos ───────────────────────────────────────────────────────
// Un pedido sin conexion NO se pierde: se guarda aqui y sale al reconectar.
function kccEncolarPedido(cuerpo){
  return kccAbrirDB().then(function(db){
    return new Promise(function(res, rej){
      var t = db.transaction('cola','readwrite');
      t.objectStore('cola').add({cuerpo:cuerpo, creado:Date.now(), intentos:0});
      t.oncomplete = function(){ res(true); };
      t.onerror    = function(){ rej(t.error); };
    });
  });
}

function kccPedidosEnCola(){
  return kccAbrirDB().then(function(db){
    return new Promise(function(res){
      var t = db.transaction('cola','readonly');
      var q = t.objectStore('cola').getAll();
      q.onsuccess = function(){ res(q.result || []); };
      q.onerror   = function(){ res([]); };
    });
  }).catch(function(){ return []; });
}

function kccBorrarDeCola(id){
  return kccAbrirDB().then(function(db){
    return new Promise(function(res){
      var t = db.transaction('cola','readwrite');
      t.objectStore('cola').delete(id);
      t.oncomplete = function(){ res(true); };
      t.onerror    = function(){ res(false); };
    });
  });
}

// Envia lo que haya en cola. Se llama al reconectar y al arrancar.
async function kccEnviarCola(){
  if(!navigator.onLine) return;
  var pend = await kccPedidosEnCola();
  if(!pend.length) return;

  var ok = 0, fallos = 0;
  for(var i=0; i<pend.length; i++){
    var p = pend[i];
    try{
      var r = await fetch(SB + '/rest/v1/pedidos_queue', {
        method:'POST',
        headers:{'apikey':KEY, 'Authorization':'Bearer '+AUTHTOK(),
                 'Content-Type':'application/json', 'Prefer':'return=minimal'},
        body: JSON.stringify(p.cuerpo)
      });
      if(r.ok){ await kccBorrarDeCola(p.id); ok++; }
      else if(r.status >= 400 && r.status < 500){
        // Error de datos: reintentarlo no va a arreglarlo. Se saca de la cola
        // para no bloquear los demas, y se avisa.
        await kccBorrarDeCola(p.id);
        fallos++;
        console.error('[offline] pedido rechazado, se descarta:', await r.text());
      } else {
        fallos++;   // 5xx o red: se queda para el proximo intento
      }
    }catch(e){ fallos++; }
  }

  if(ok || fallos) kccAviso(
    ok + ' pedido(s) enviado(s)' + (fallos ? ' · ' + fallos + ' pendiente(s)' : ''),
    fallos ? 'amber' : 'green');
  kccPintarEstado();
}

// ── Aviso en pantalla ─────────────────────────────────────────────────────
function kccAviso(texto, color){
  var d = document.getElementById('kcc-aviso');
  if(!d){
    d = document.createElement('div');
    d.id = 'kcc-aviso';
    d.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:88px;'
      + 'z-index:9999;padding:10px 18px;border-radius:22px;font-size:13px;font-weight:600;'
      + 'box-shadow:0 6px 22px rgba(0,0,0,.2);transition:opacity .3s';
    document.body.appendChild(d);
  }
  var cols = {green:'#059669', amber:'#D97706', red:'#DC2626', gris:'#374151'};
  d.style.background = cols[color] || cols.gris;
  d.style.color = '#fff';
  d.style.opacity = '1';
  d.textContent = texto;
  clearTimeout(kccAviso._t);
  kccAviso._t = setTimeout(function(){ d.style.opacity = '0'; }, 4200);
}

// Indicador permanente cuando no hay conexion o hay pedidos esperando.
async function kccPintarEstado(){
  var pend = await kccPedidosEnCola();
  var b = document.getElementById('kcc-estado');

  if(navigator.onLine && !pend.length){
    if(b) b.remove();
    return;
  }
  if(!b){
    b = document.createElement('div');
    b.id = 'kcc-estado';
    b.style.cssText = 'position:fixed;right:14px;bottom:14px;z-index:9998;'
      + 'padding:8px 14px;border-radius:20px;font-size:12px;font-weight:700;'
      + 'box-shadow:0 4px 16px rgba(0,0,0,.18);cursor:pointer';
    b.onclick = function(){ if(navigator.onLine) kccEnviarCola(); };
    document.body.appendChild(b);
  }
  if(!navigator.onLine){
    b.style.background = '#DC2626'; b.style.color = '#fff';
    b.textContent = '\u26A0 Sin conexi\u00f3n' + (pend.length ? (' \u00b7 ' + pend.length + ' por enviar') : '');
    b.title = 'Cat\u00e1logo y clientes salen de los datos descargados. '
      + 'Los pedidos se guardan y se env\u00edan al recuperar la conexi\u00f3n. '
      + 'No cierres ni recargues esta pesta\u00f1a.';
  } else {
    b.style.background = '#D97706'; b.style.color = '#fff';
    b.textContent = '\u21bb ' + pend.length + ' pedido(s) por enviar';
    b.title = 'Pulsa para enviarlos ahora';
  }
}

// ── Registro del Service Worker ───────────────────────────────────────────
function kccIniciar(){
  // El Service Worker es OPCIONAL. En Shopify no se puede servir un archivo
  // desde la raiz del dominio, y un SW solo controla paginas de su mismo
  // origen: si no esta, se registra nada y ya.
  //
  // Lo que de verdad hace falta —catalogo guardado y cola de pedidos— vive en
  // IndexedDB y funciona igual sin el. Lo unico que se pierde es poder ABRIR
  // el portal de cero sin internet; con la pestana ya abierta, todo va.
  if(!('serviceWorker' in navigator)) return;
  var ruta = window.KCC_SW_URL;
  if(!ruta) return;                      // no configurado: se omite en silencio
  navigator.serviceWorker.register(ruta, {scope:'/pages/'})
    .then(function(){ console.log('[offline] service worker activo'); })
    .catch(function(){
      // Es lo esperado en Shopify. No se avisa al usuario porque no cambia
      // nada de lo que puede hacer.
      console.log('[offline] sin service worker; el resto funciona igual');
    });
}

window.addEventListener('online',  function(){
  KCC_ONLINE = true;
  kccAviso('Conexi\u00f3n recuperada', 'green');
  kccEnviarCola();
});
window.addEventListener('offline', function(){
  KCC_ONLINE = false;
  kccAviso('Sin conexi\u00f3n \u00b7 sigue trabajando, NO cierres esta pesta\u00f1a', 'red');
  kccPintarEstado();
});

// Si se intenta cerrar con pedidos sin enviar, se avisa: cerrar la pestana
// sin conexion obliga a volver a abrirla con internet para recuperarlos.
window.addEventListener('beforeunload', function(e){
  if(navigator.onLine) return;
  var b = document.getElementById('kcc-estado');
  if(b && /por enviar/.test(b.textContent||'')){
    e.preventDefault();
    e.returnValue = '';
  }
});

document.addEventListener('DOMContentLoaded', function(){
  kccIniciar();
  setTimeout(function(){ kccPintarEstado(); kccEnviarCola(); }, 1500);
});


/* ============================================================================
   PRECARGA COMPLETA
   ---------------------------------------------------------------------------
   Descarga TODO el catalogo y todos los clientes al dispositivo, para poder
   armar pedidos en zonas sin cobertura sin haber consultado nada antes.

   Son unos 31 MB y algo mas de un minuto con buena conexion. Se guarda por
   bloques segun llegan, asi que si se corta a la mitad, lo bajado sirve y
   la siguiente vez continua desde ahi.
============================================================================ */

var KCC_PRE = { activa:false, cancelar:false };

// Los articulos se guardan en bloques de 2.000: uno solo de 140.000 haria
// que cada lectura tuviera que cargar los 27 MB en memoria.
var KCC_BLOQUE = 2000;

async function kccDescargarTodo(onProg){
  if(KCC_PRE.activa) return;
  KCC_PRE.activa = true; KCC_PRE.cancelar = false;

  function prog(fase, hechos, total){
    if(onProg) onProg(fase, hechos, total);
  }

  try{
    // ── Clientes ──────────────────────────────────────────────────────────
    prog('clientes', 0, 0);
    var cli = [], desde = 0, PAG = 1000;
    while(!KCC_PRE.cancelar){
      var r = await q('clientes',
        'select=cardcode,cardname,cardtype,city,country,balance,creditline,condicionpago,slpcode,e_mail,cellular,phone1,nombrevendedor'
        + '&cardtype=eq.C&order=cardcode&limit=' + PAG + '&offset=' + desde);
      if(!r || !r.length) break;
      cli = cli.concat(r);
      desde += r.length;
      prog('clientes', cli.length, 0);
      if(r.length < PAG) break;
    }
    if(KCC_PRE.cancelar) throw new Error('cancelado');

    // Se guardan en bloques y con un indice por codigo, para poder buscar
    // sin cargar los 21.000 en memoria.
    for(var i=0; i<cli.length; i+=KCC_BLOQUE){
      await kccGuardar('cli:'+Math.floor(i/KCC_BLOQUE), cli.slice(i, i+KCC_BLOQUE));
    }
    await kccGuardar('cli:meta', {n:cli.length, bloques:Math.ceil(cli.length/KCC_BLOQUE), fecha:Date.now()});

    // ── Articulos ─────────────────────────────────────────────────────────
    prog('articulos', 0, 0);
    var art = [], d2 = 0;
    while(!KCC_PRE.cancelar){
      var r2 = await q('vista_inventario',
        'select=itemcode,itemname,precioventa,disponible,onhand,onorder,comprometido,unidadesbulto,'
        + 'marca,grupo,subg,tipo,codebars,picturname,foto_url,fechaentrada,peso,volumen,'
        + 'tamano,composicion,color,cubicaje,ultimocosto'
        + '&order=itemcode&limit=' + PAG + '&offset=' + d2);
      if(!r2 || !r2.length) break;
      art = art.concat(r2);
      d2 += r2.length;
      prog('articulos', art.length, 0);
      if(r2.length < PAG) break;

      // Guardado parcial: si se corta la descarga, lo bajado no se pierde.
      if(art.length % 20000 === 0){
        for(var j=0; j<art.length; j+=KCC_BLOQUE){
          await kccGuardar('art:'+Math.floor(j/KCC_BLOQUE), art.slice(j, j+KCC_BLOQUE));
        }
        await kccGuardar('art:meta', {n:art.length, bloques:Math.ceil(art.length/KCC_BLOQUE), fecha:Date.now(), parcial:true});
      }
    }
    if(KCC_PRE.cancelar) throw new Error('cancelado');

    for(var k=0; k<art.length; k+=KCC_BLOQUE){
      await kccGuardar('art:'+Math.floor(k/KCC_BLOQUE), art.slice(k, k+KCC_BLOQUE));
    }
    await kccGuardar('art:meta', {n:art.length, bloques:Math.ceil(art.length/KCC_BLOQUE), fecha:Date.now()});

    prog('listo', art.length, cli.length);
    return {articulos:art.length, clientes:cli.length};

  } finally {
    KCC_PRE.activa = false;
  }
}

// ── Lectura de lo precargado ────────────────────────────────────────────────
async function kccBuscarArticulos(texto, limite){
  var meta = await kccLeer('art:meta');
  if(!meta || !meta.v) return null;              // no hay precarga
  var t = String(texto||'').trim().toUpperCase();
  if(!t) return [];
  var out = [];
  for(var b=0; b<meta.v.bloques && out.length<(limite||60); b++){
    var blo = await kccLeer('art:'+b);
    if(!blo || !blo.v) continue;
    for(var i=0; i<blo.v.length; i++){
      var a = blo.v[i];
      if(String(a.itemcode||'').toUpperCase().indexOf(t)>=0 ||
         String(a.itemname||'').toUpperCase().indexOf(t)>=0 ||
         String(a.codebars||'')===t){
        out.push(a);
        if(out.length>=(limite||60)) break;
      }
    }
  }
  return out;
}

// Los primeros N articulos, para poder mostrar algo en el catalogo sin que
// el vendedor tenga que escribir una busqueda. Se priorizan los que tienen
// existencia: son los unicos que se pueden vender.
async function kccPrimerosArticulos(limite){
  var meta = await kccLeer('art:meta');
  if(!meta || !meta.v) return null;
  var conStock = [], sinStock = [];
  var tope = limite || 80;
  for(var b=0; b<meta.v.bloques && conStock.length < tope; b++){
    var blo = await kccLeer('art:'+b);
    if(!blo || !blo.v) continue;
    for(var i=0; i<blo.v.length && conStock.length < tope; i++){
      var a = blo.v[i];
      if((Number(a.disponible)||0) > 0) conStock.push(a);
      else if(sinStock.length < tope) sinStock.push(a);
    }
  }
  return conStock.length ? conStock : sinStock.slice(0, tope);
}

async function kccArticuloPorCodigo(code){
  var meta = await kccLeer('art:meta');
  if(!meta || !meta.v) return null;
  var c = String(code||'').toUpperCase();
  for(var b=0; b<meta.v.bloques; b++){
    var blo = await kccLeer('art:'+b);
    if(!blo || !blo.v) continue;
    for(var i=0; i<blo.v.length; i++){
      if(String(blo.v[i].itemcode||'').toUpperCase()===c ||
         String(blo.v[i].codebars||'')===String(code)) return blo.v[i];
    }
  }
  return null;
}

async function kccBuscarClientes(texto, limite){
  var meta = await kccLeer('cli:meta');
  if(!meta || !meta.v) return null;
  var t = String(texto||'').trim().toUpperCase();
  if(!t) return [];
  var out = [];
  for(var b=0; b<meta.v.bloques && out.length<(limite||30); b++){
    var blo = await kccLeer('cli:'+b);
    if(!blo || !blo.v) continue;
    for(var i=0; i<blo.v.length; i++){
      var c = blo.v[i];
      if(String(c.cardcode||'').toUpperCase().indexOf(t)>=0 ||
         String(c.cardname||'').toUpperCase().indexOf(t)>=0){
        out.push(c);
        if(out.length>=(limite||30)) break;
      }
    }
  }
  return out;
}

// ── Estado de la precarga, para mostrarlo ──────────────────────────────────
async function kccEstadoPrecarga(){
  var a = await kccLeer('art:meta');
  var c = await kccLeer('cli:meta');
  return {
    articulos: a && a.v ? a.v.n : 0,
    clientes:  c && c.v ? c.v.n : 0,
    fecha:     a && a.v ? a.v.fecha : null,
    parcial:   a && a.v ? !!a.v.parcial : false
  };
}

// ── Ventana de descarga ────────────────────────────────────────────────────
async function kccAbrirPrecarga(){
  var est = await kccEstadoPrecarga();
  var m = document.createElement('div');
  m.id = 'kcc-pre-modal';
  m.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    + 'display:flex;align-items:center;justify-content:center;padding:14px';

  var dias = est.fecha ? Math.floor((Date.now()-est.fecha)/86400000) : null;
  var nFotos = await kccContarFotos();
  var hist = await kccEstadoHistorial();

  m.innerHTML = '<div style="background:var(--surface,#fff);border-radius:14px;max-width:470px;width:100%;padding:20px">'
    + '<div style="display:flex;align-items:center;gap:10px;margin-bottom:12px">'
      + '<b style="flex:1;font-size:15px">\u{1F4F6} Datos para trabajar sin internet</b>'
      + '<button onclick="kccCerrarPrecarga()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    + '</div>'
    + (est.articulos
        ? ('<div style="background:#ECFDF5;border:1px solid #A7F3D0;border-radius:9px;padding:11px 13px;font-size:13px;margin-bottom:14px">'
           + '<b style="color:#065F46">Ya tienes los datos descargados</b><br>'
           + '<span style="color:var(--text3);font-size:12.5px">'
           + fmtN(est.articulos) + ' art\u00edculos \u00b7 ' + fmtN(est.clientes) + ' clientes'
           + (dias!==null ? (' \u00b7 hace ' + (dias===0?'menos de un d\u00eda':(dias+' d\u00eda'+(dias===1?'':'s'))) ) : '')
           + (est.parcial ? ' \u00b7 <b style="color:#B45309">descarga incompleta</b>' : '')
           + '</span></div>')
        : ('<div style="font-size:13px;color:var(--text3);margin-bottom:14px;line-height:1.55">'
           + 'Descarga el cat\u00e1logo y los clientes al iPad para poder armar pedidos '
           + 'aunque no haya se\u00f1al.</div>'))
    + '<div style="font-size:12.5px;color:var(--text3);line-height:1.6;margin-bottom:14px">'
      + 'Ocupa unos <b>30 MB</b> y tarda un par de minutos.<br>'
      + 'Hazlo con wifi, no con datos m\u00f3viles.'
    + '</div>'
    // Historial: facturas, pedidos y estado de cuenta de los ultimos 24 meses.
    + '<div style="border-top:1px solid var(--border);margin:14px 0 12px;padding-top:13px">'
      + '<div style="font-size:13px;font-weight:600;margin-bottom:5px">Historial (24 meses)</div>'
      + '<div style="font-size:12.5px;color:var(--text3);line-height:1.55;margin-bottom:9px">'
      + (hist.hay
          ? ('<b style="color:#065F46">' + fmtN(hist.facturas) + ' l\u00edneas de factura \u00b7 '
             + fmtN(hist.pedidos) + ' de pedido</b><br>')
          : '')
      + 'Facturas, pedidos y estado de cuenta por cliente. Unos <b>120 MB</b>, '
      + 'cinco minutos.<br>Con esto funcionan las fichas de cliente y el restock sin se\u00f1al.'
      + '</div>'
      + '<div style="display:flex;gap:7px;flex-wrap:wrap">'
        + '<button class="btn btn-sm" id="kcc-hist-btn" onclick="kccLanzarHistorial()"'
        + (est.articulos ? '' : ' disabled title="Primero descarga los datos"') + '>'
        + (hist.hay ? 'Actualizar historial' : 'Descargar historial') + '</button>'
      + '</div>'
      + '<div id="kcc-hist-prog" style="font-size:12.5px;margin-top:9px"></div>'
    + '</div>'

    // Las fotos van aparte: quince minutos frente a cinco del historial.
    + '<div style="border-top:1px solid var(--border);margin:14px 0 12px;padding-top:13px">'
      + '<div style="font-size:13px;font-weight:600;margin-bottom:5px">Fotos de los art\u00edculos</div>'
      + '<div style="font-size:12.5px;color:var(--text3);line-height:1.55;margin-bottom:9px">'
      + (nFotos
          ? ('<b style="color:#065F46">' + fmtN(nFotos) + ' fotos guardadas</b><br>')
          : '')
      + 'Solo de lo que tiene existencia. Ocupa unos <b>160 MB</b> y tarda '
      + '10-15 minutos.<br>Sin esto, sin conexi\u00f3n se ven los art\u00edculos pero no sus fotos.'
      + '</div>'
      + '<div style="display:flex;gap:7px;flex-wrap:wrap">'
        + '<button class="btn btn-sm" id="kcc-foto-btn" onclick="kccLanzarFotos()"'
        + (est.articulos ? '' : ' disabled title="Primero descarga los datos"') + '>'
        + (nFotos ? 'Actualizar fotos' : 'Descargar fotos') + '</button>'
        + (nFotos ? '<button class="btn btn-sm" onclick="kccQuitarFotos()">Borrar fotos</button>' : '')
      + '</div>'
      + '<div id="kcc-foto-prog" style="font-size:12.5px;margin-top:9px"></div>'
    + '</div>'
    + '<div id="kcc-pre-prog" style="font-size:13px;margin-bottom:12px"></div>'
    + '<div style="display:flex;gap:8px;justify-content:flex-end">'
      + '<button class="btn btn-sm" onclick="kccCerrarPrecarga()">Cerrar</button>'
      + '<button class="btn btn-sm btn-p" id="kcc-pre-btn" onclick="kccLanzarPrecarga()">'
      + (est.articulos ? 'Actualizar datos' : 'Descargar ahora') + '</button>'
    + '</div></div>';
  document.body.appendChild(m);
}

function kccCerrarPrecarga(){
  KCC_PRE.cancelar = true;
  var m = document.getElementById('kcc-pre-modal');
  if(m) m.remove();
}

async function kccLanzarHistorial(){
  var p = document.getElementById('kcc-hist-prog');
  var b = document.getElementById('kcc-hist-btn');
  if(b){ b.disabled = true; b.textContent = 'Descargando\u2026'; }

  var etiquetas = {
    facturas:'Facturas', pedidos:'Pedidos', estado:'Estado de cuenta',
    porllegar:'Mercanc\u00eda por llegar', devoluciones:'Devoluciones'
  };
  try{
    await kccDescargarHistorial(function(fase, n){
      if(!p) return;
      if(fase==='listo'){ return; }
      p.style.color = 'var(--text3)';
      p.innerHTML = '<div class="spinner" style="display:inline-block;vertical-align:middle;margin-right:8px"></div>'
        + (etiquetas[fase]||fase) + '\u2026 ' + fmtN(n) + ' l\u00ednea(s)';
    });
    var h = await kccEstadoHistorial();
    if(p){
      p.style.color = 'var(--green)';
      p.innerHTML = '\u2713 ' + fmtN(h.facturas) + ' l\u00edneas de factura, '
        + fmtN(h.pedidos) + ' de pedido y ' + fmtN(h.movimientos) + ' movimientos.';
    }
    if(b){ b.disabled = false; b.textContent = 'Actualizar historial'; }
    kccAviso('Historial descargado', 'green');
    try{ kccPintarTarjeta(); }catch(e){}
  }catch(e){
    if(p){
      p.style.color = String(e.message)==='cancelado' ? 'var(--text3)' : 'var(--red)';
      p.textContent = String(e.message)==='cancelado'
        ? 'Cancelado. Lo bajado se conserva.'
        : ('No se pudo completar: ' + String(e.message||e).slice(0,120));
    }
    if(b){ b.disabled = false; b.textContent = 'Reintentar'; }
  }
}

async function kccLanzarFotos(){
  var p = document.getElementById('kcc-foto-prog');
  var b = document.getElementById('kcc-foto-btn');
  if(b){ b.disabled = true; b.textContent = 'Descargando\u2026'; }
  var t0 = Date.now();

  try{
    var r = await kccDescargarFotos(function(hechos, total, yaTengo){
      if(!p) return;
      p.style.color = 'var(--text3)';
      if(!total){ p.textContent = 'Ya estaban todas (' + fmtN(yaTengo) + ').'; return; }
      var pct = Math.round(hechos/total*100);
      // Estimacion del tiempo restante, para no dejar a nadie a ciegas
      // quince minutos mirando una barra.
      var falta = '';
      if(hechos > 20){
        var seg = (Date.now()-t0)/1000, resto = (total-hechos)*(seg/hechos);
        falta = resto > 60 ? (' \u00b7 faltan ~' + Math.ceil(resto/60) + ' min')
                           : (' \u00b7 faltan ~' + Math.ceil(resto) + ' s');
      }
      p.innerHTML = '<div class="spinner" style="display:inline-block;vertical-align:middle;margin-right:8px"></div>'
        + fmtN(hechos) + ' de ' + fmtN(total) + ' (' + pct + '%)' + falta
        + '<div style="height:5px;background:var(--surface2,#F1F2F4);border-radius:3px;margin-top:6px">'
        + '<div style="height:100%;width:' + pct + '%;background:var(--green);border-radius:3px"></div></div>';
    });

    if(p){
      p.style.color = 'var(--green)';
      var _sin = r.fallos || 0;
      p.innerHTML = (r.bajadas
          ? ('\u2713 ' + fmtN(r.bajadas) + ' foto(s) nuevas')
          : '<span style="color:var(--amber)">No se guard\u00f3 ninguna foto</span>')
        + (r.yaTengo ? (' \u00b7 ' + fmtN(r.yaTengo) + ' ya estaban') : '')
        + (_sin ? ('<br><span style="color:var(--amber)">' + fmtN(_sin)
                   + ' no se pudieron descargar</span>') : '')
        + (!r.bajadas && !r.yaTengo
            ? '<br><span style="font-size:11.5px;color:var(--text3)">'
              + 'Mira la consola (F12): ah\u00ed sale el motivo.</span>' : '');
    }
    if(b){ b.disabled = false; b.textContent = 'Actualizar fotos'; }
    _KCC_FOTO_SET = null;   // el indice cambio
    try{ kccPintarTarjeta(); }catch(e){}
  }catch(e){
    if(p){ p.style.color='var(--red)'; p.textContent = String(e.message||e).slice(0,150); }
    if(b){ b.disabled = false; b.textContent = 'Reintentar'; }
  }
}

async function kccQuitarFotos(){
  if(!confirm('\u00bfBorrar las fotos guardadas?\n\nLos art\u00edculos y clientes se conservan: '
    + 'solo se liberan los ~160 MB de im\u00e1genes.')) return;
  var n = await kccBorrarFotos();
  kccAviso(fmtN(n) + ' fotos borradas', 'gris');
  kccCerrarPrecarga(); kccAbrirPrecarga();
}

async function kccLanzarPrecarga(){
  var p = document.getElementById('kcc-pre-prog');
  var b = document.getElementById('kcc-pre-btn');
  if(b){ b.disabled = true; b.textContent = 'Descargando\u2026'; }

  try{
    var r = await kccDescargarTodo(function(fase, hechos){
      if(!p) return;
      p.style.color = 'var(--text3)';
      if(fase==='clientes')  p.innerHTML = '<div class="spinner" style="display:inline-block;vertical-align:middle;margin-right:8px"></div>Clientes\u2026 ' + fmtN(hechos);
      if(fase==='articulos') p.innerHTML = '<div class="spinner" style="display:inline-block;vertical-align:middle;margin-right:8px"></div>Art\u00edculos\u2026 ' + fmtN(hechos);
    });
    if(p){
      p.style.color = 'var(--green)';
      p.innerHTML = '\u2713 Listo: ' + fmtN(r.articulos) + ' art\u00edculos y ' + fmtN(r.clientes) + ' clientes guardados.';
    }
    if(b){ b.disabled = false; b.textContent = 'Actualizar datos'; }
    kccAviso('Datos descargados. Ya puedes trabajar sin internet.', 'green');
    try{ kccPintarTarjeta(); }catch(e){}
  }catch(e){
    if(p){
      p.style.color = 'var(--red)';
      p.textContent = String(e.message)==='cancelado'
        ? 'Descarga cancelada. Lo bajado se conserva.'
        : ('No se pudo completar: ' + String(e.message||e).slice(0,120));
    }
    if(b){ b.disabled = false; b.textContent = 'Reintentar'; }
  }
}


/* ============================================================================
   MINIATURAS SIN CONEXION
   ---------------------------------------------------------------------------
   Solo de los articulos CON EXISTENCIA: son los unicos que se pueden vender.
   Cada foto se reduce a 120px y se guarda como JPEG de calidad media, unos
   8 KB. Con ~20.000 articulos con stock son unos 160 MB.

   Va aparte de la descarga de datos a proposito: 31 MB tardan un minuto y
   160 MB tardan quince. Quien solo quiera poder pedir sin señal no necesita
   esperar por las fotos.
============================================================================ */

var KCC_FOTOS = { activa:false, cancelar:false };
var KCC_FOTO_PX = 120;
var KCC_FOTO_HILOS = 6;      // en paralelo; mas satura la red del iPad

// Reduce una imagen a 120px y la devuelve como texto para poder guardarla.
function _kccMini(url){
  // Se descarga con fetch y se convierte a Blob ANTES de tocarla, en vez de
  // cargarla en un <img> con crossOrigin. Ese camino fallaba en silencio: si
  // el servidor no da permiso CORS, el canvas queda bloqueado y toBlob()
  // devuelve null sin lanzar error. De ahi que la descarga terminara con
  // cero fotos guardadas teniendo 29.817 disponibles.
  return new Promise(function(res){
    fetch(url, {mode:'cors', cache:'force-cache'})
      .then(function(r){ return r.ok ? r.blob() : null; })
      .then(function(bl){
        if(!bl || !bl.size) return res(null);
        // Si no se puede reducir, se guarda la original: pesa mas, pero es
        // preferible a quedarse sin foto.
        _kccReducir(bl).then(function(mini){ res(mini || bl); })
                       .catch(function(){ res(bl); });
      })
      .catch(function(){ res(null); });
  });
}

// Reduce un Blob de imagen a KCC_FOTO_PX. Con createImageBitmap no hace falta
// pasar por <img> ni por CORS: el Blob ya esta en memoria.
function _kccReducir(blob){
  return new Promise(function(res, rej){
    if(!window.createImageBitmap) return rej(new Error('sin createImageBitmap'));
    var t = setTimeout(function(){ rej(new Error('tardo demasiado')); }, 15000);
    createImageBitmap(blob).then(function(bmp){
      clearTimeout(t);
      var w=bmp.width, h=bmp.height, m=KCC_FOTO_PX;
      if(w>m || h>m){
        if(w>h){ h=Math.round(h*m/w); w=m; } else { w=Math.round(w*m/h); h=m; }
      }
      var c=document.createElement('canvas'); c.width=w; c.height=h;
      var ctx=c.getContext('2d');
      ctx.fillStyle='#fff'; ctx.fillRect(0,0,w,h);
      ctx.drawImage(bmp,0,0,w,h);
      try{ bmp.close(); }catch(e){}
      c.toBlob(function(bl){ res(bl); }, 'image/jpeg', 0.68);
    }).catch(function(e){ clearTimeout(t); rej(e); });
  });
}

// Las miniaturas van en su propio almacen: asi se pueden borrar sin tocar
// el catalogo, que es lo que de verdad hace falta para pedir.
function kccGuardarFoto(code, blob){
  return kccAbrirDB().then(function(db){
    return new Promise(function(res){
      var t=db.transaction('datos','readwrite');
      t.objectStore('datos').put({k:'foto:'+code, v:blob, t:Date.now()});
      t.oncomplete=function(){ res(true); };
      t.onerror   =function(){ res(false); };
    });
  }).catch(function(){ return false; });
}

// Devuelve una URL utilizable en un <img>. Los objetos URL creados se
// recuerdan para no generar uno nuevo cada vez que se pinta el catalogo.
var _kccFotoURL = {};

async function kccFotoDe(code){
  var c = String(code);
  if(_kccFotoURL[c]) return _kccFotoURL[c];
  var r = await kccLeer('foto:'+c);
  if(!r || !r.v) return null;
  try{
    var u = (typeof r.v === 'string') ? r.v : URL.createObjectURL(r.v);
    _kccFotoURL[c] = u;
    return u;
  }catch(e){ return null; }
}

// Descarga las miniaturas de todo lo que tenga existencia.
async function kccDescargarFotos(onProg){
  if(KCC_FOTOS.activa) return;
  KCC_FOTOS.activa=true; KCC_FOTOS.cancelar=false;

  try{
    // La lista sale del catalogo ya descargado: no hace falta volver a pedirla.
    var meta = await kccLeer('art:meta');
    if(!meta || !meta.v) throw new Error('Primero hay que descargar el cat\u00e1logo.');

    var pend=[], yaTengo=0;
    for(var b=0; b<meta.v.bloques; b++){
      var blo = await kccLeer('art:'+b);
      if(!blo || !blo.v) continue;
      for(var i=0; i<blo.v.length; i++){
        var a=blo.v[i];
        if((Number(a.disponible)||0) <= 0) continue;      // sin stock, no se vende
        if(!a.picturname && !a.foto_url) continue;        // sin foto, nada que bajar
        pend.push(a);
      }
    }

    // Las que ya estan no se vuelven a bajar: al repetir la descarga solo
    // entran las nuevas, y eso la hace mucho mas corta.
    var falta=[];
    for(var k=0; k<pend.length; k++){
      var t = await kccLeer('foto:'+pend[k].itemcode);
      if(t) yaTengo++; else falta.push(pend[k]);
    }

    if(onProg) onProg(0, falta.length, yaTengo);
    if(!falta.length) return {bajadas:0, total:pend.length, yaTengo:yaTengo};

    var idx=0, ok=0, fallos=0;
    async function trabajar(){
      while(idx < falta.length && !KCC_FOTOS.cancelar){
        var a = falta[idx++];
        // fotoPair da la URL principal y sus respaldos; se prueban en orden.
        var cands=[];
        try{
          // La ORIGINAL, no la sustituida: la mia devuelve vacio sin conexion
          // y aqui hacen falta las URLs reales del servidor.
          var _fp = window._KCC_FOTOPAIR || fotoPair;
          var pp = _fp(a.picturname, a.foto_url);
          if(pp.primary) cands.push(pp.primary);
          if(pp.fb) cands = cands.concat(String(pp.fb).split('|').filter(Boolean));
        }catch(e){ if(a.foto_url) cands=[a.foto_url]; }

        var mini=null;
        for(var c=0; c<cands.length && !mini; c++) mini = await _kccMini(cands[c]);

        if(mini){ await kccGuardarFoto(a.itemcode, mini); ok++; }
        else {
          fallos++;
          // Se deja constancia de los primeros fallos: si algo va mal con el
          // servidor de fotos, aqui se ve el motivo en vez de terminar con
          // cero y sin explicacion.
          if(fallos <= 5) console.warn('[fotos] no se pudo bajar', a.itemcode, cands);
        }
        if(onProg) onProg(ok+fallos, falta.length, yaTengo);
      }
    }
    var hilos=[];
    for(var h=0; h<KCC_FOTO_HILOS; h++) hilos.push(trabajar());
    await Promise.all(hilos);

    return {bajadas:ok, fallos:fallos, total:pend.length, yaTengo:yaTengo};
  } finally {
    KCC_FOTOS.activa=false;
  }
}

async function kccContarFotos(){
  return kccAbrirDB().then(function(db){
    return new Promise(function(res){
      var t=db.transaction('datos','readonly');
      var q2=t.objectStore('datos').getAllKeys();
      q2.onsuccess=function(){
        res((q2.result||[]).filter(function(k){ return String(k).indexOf('foto:')===0; }).length);
      };
      q2.onerror=function(){ res(0); };
    });
  }).catch(function(){ return 0; });
}

async function kccBorrarFotos(){
  var db = await kccAbrirDB();
  var claves = await new Promise(function(res){
    var t=db.transaction('datos','readonly');
    var q2=t.objectStore('datos').getAllKeys();
    q2.onsuccess=function(){ res((q2.result||[]).filter(function(k){ return String(k).indexOf('foto:')===0; })); };
    q2.onerror=function(){ res([]); };
  });
  var t2=db.transaction('datos','readwrite');
  var st=t2.objectStore('datos');
  claves.forEach(function(k){ st.delete(k); });
  return claves.length;
}


/* ============================================================================
   RESPUESTAS SIN CONEXION
   ---------------------------------------------------------------------------
   Devuelve datos desde lo guardado en el dispositivo. Lo llama q() en
   kennedy-1.js, que es por donde pasan TODAS las consultas del portal.

   Devuelve null cuando esa tabla no esta guardada: entonces q() sigue su
   curso normal y falla como siempre, que es lo correcto —mejor un error
   claro que datos inventados.
============================================================================ */

// Traduce los filtros de PostgREST a algo que se pueda aplicar en memoria.
// Solo los que usan las pantallas: igualdad, contiene, mayor/menor y en-lista.
function _kccFiltros(params){
  var fs = [];
  String(params||'').split('&').forEach(function(p){
    var i = p.indexOf('=');
    if(i < 0) return;
    var campo = p.slice(0, i);
    var valor = decodeURIComponent(p.slice(i+1));
    if(['select','order','limit','offset','and','or'].indexOf(campo) >= 0) return;

    var m = valor.match(/^(eq|neq|gt|gte|lt|lte|like|ilike|in|is|not)\.(.*)$/s);
    if(!m) return;
    fs.push({campo: campo, op: m[1], valor: m[2]});
  });
  return fs;
}

function _kccPasa(fila, f){
  var v = fila[f.campo];
  var t = f.valor;
  switch(f.op){
    case 'eq':  return String(v) === t;
    case 'neq': return String(v) !== t;
    case 'gt':  return Number(v) >  Number(t);
    case 'gte': return Number(v) >= Number(t);
    case 'lt':  return Number(v) <  Number(t);
    case 'lte': return Number(v) <= Number(t);
    case 'is':  return (t === 'null') ? (v == null) : (String(v) === t);
    case 'in':
      var lista = t.replace(/^\(|\)$/g,'').split(',').map(function(x){
        return x.trim().replace(/^"|"$/g,'');
      });
      return lista.indexOf(String(v)) >= 0;
    case 'like':
    case 'ilike':
      var pat = t.replace(/\*/g,'%');
      var re = new RegExp('^' + pat.split('%').map(function(x){
        return x.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
      }).join('.*') + '$', f.op==='ilike' ? 'i' : '');
      return re.test(String(v==null?'':v));
    default: return true;
  }
}

// Lee todos los bloques de un almacen y los junta.
async function _kccTodos(prefijo){
  var meta = await kccLeer(prefijo + ':meta');
  if(!meta || !meta.v) return null;
  var out = [];
  for(var b = 0; b < meta.v.bloques; b++){
    var blo = await kccLeer(prefijo + ':' + b);
    if(blo && blo.v) out = out.concat(blo.v);
  }
  return out;
}

// Qué tabla del portal sale de qué almacén local.
var KCC_TABLAS = {
  'clientes':              'cli',
  'vista_clientes':        'cli',
  'vista_clientes_perfil': 'cli',   // la usa la pantalla de Clientes
  'inventario':            'art',
  'vista_inventario':      'art',
  'vista_wms_vs_sap':      'art',   // parte del inventario
  'vista_facturas':        null     // se resuelve por cliente, mas abajo
};

// Vistas que se arman a partir de lo descargado en vez de leerse tal cual.
// El resto (NAPA, entregas, WMS, ordenes de compra, borradores...) no se guarda:
// esas pantallas avisan de que necesitan conexion, que es lo correcto.
var KCC_DERIVADAS = {
  'grupos_inventario': 'grupo',
  'marcas_inventario': 'marca'
};

// Saca la lista de departamentos o marcas del propio catalogo guardado.
async function _kccDerivada(campo){
  var art = await _kccCatalogo();
  if(!art) return null;
  var c = {};
  art.forEach(function(a){ var v = a[campo]; if(v) c[v] = (c[v]||0) + 1; });
  return Object.keys(c).sort().map(function(v){
    var o = {n: c[v]};
    o[campo] = v;
    return o;
  });
}

// Tablas guardadas POR CLIENTE. Se leen de un tiron cuando la consulta filtra
// por cardcode, que es como las pide el portal casi siempre.
var KCC_POR_CLIENTE = {
  'facturas':        'fac',
  'vista_facturas':  'fac',
  'pedidos':         'ped',
  'movimientos':     'mov',
  'estado_cuenta':   'mov',
  'devoluciones':    'dev'
};

async function kccOffline(tabla, params){
  var filas = null;

  // Departamentos y marcas: se sacan del catalogo, no hacen falta descargarlos.
  if(KCC_DERIVADAS[tabla]){
    var der = await _kccDerivada(KCC_DERIVADAS[tabla]);
    if(der) return der;
    return null;
  }

  // Tablas por cliente: se lee solo su registro. Es lo que permite responder
  // al instante en vez de recorrer cientos de miles de filas.
  var pc = KCC_POR_CLIENTE[tabla];
  if(pc){
    var mc = String(params||'').match(/[?&]cardcode=eq\.([^&]+)/);
    if(mc){
      var reg = await kccLeer(pc + ':' + decodeURIComponent(mc[1]));
      filas = reg && reg.v ? reg.v.slice() : [];
    } else {
      // Sin filtro de cliente habria que juntar todos: no se hace, porque
      // seria lentisimo y ninguna pantalla lo pide asi.
      return null;
    }
  }

  if(filas === null){
    var prefijo = KCC_TABLAS[tabla];
    if(!prefijo) return null;               // no guardada: que falle normal
    filas = await _kccTodos(prefijo);
    if(!filas) return null;                 // sin descargar
  }

  // vista_clientes_perfil anade columnas calculadas (ultima compra, total
  // facturado, dias sin comprar). Sin conexion no se pueden calcular: se
  // rellenan desde el historial si esta descargado, y si no quedan vacias.
  // Es preferible a que la pantalla no cargue.
  if(tabla === 'vista_clientes_perfil'){
    filas = filas.map(function(c){
      var o = Object.assign({}, c);
      if(o.total_facturado == null) o.total_facturado = null;
      if(o.ultima_compra   == null) o.ultima_compra   = null;
      if(o.dias_sin_comprar == null) o.dias_sin_comprar = null;
      return o;
    });
  }

  // Filtros. Solo se aplican los que se puedan comprobar: al descargar se
  // guardan unas columnas concretas, y filtrar por una que no esta —como
  // cardtype, que no se descarga— dejaria la lista vacia siempre.
  var campos = filas.length ? Object.keys(filas[0]) : [];
  var fs = _kccFiltros(params).filter(function(f){
    if(campos.indexOf(f.campo) >= 0) return true;
    console.debug('[offline] filtro ignorado, campo no guardado:', f.campo);
    return false;
  });
  if(fs.length){
    filas = filas.filter(function(r){
      for(var i=0; i<fs.length; i++) if(!_kccPasa(r, fs[i])) return false;
      return true;
    });
  }

  // Búsqueda combinada: or=(campo.ilike.*x*,otro.ilike.*x*)
  var mo = String(params||'').match(/[?&]or=\(([^)]*)\)/);
  if(mo && campos.length){
    var alts = mo[1].split(',').map(function(t){
      var p = t.split('.');
      return {campo:p[0], op:p[1], valor:decodeURIComponent(p.slice(2).join('.'))};
    }).filter(function(a){ return campos.indexOf(a.campo) >= 0; });
    if(alts.length){
      filas = filas.filter(function(r){
        for(var i=0; i<alts.length; i++) if(_kccPasa(r, alts[i])) return true;
        return false;
      });
    }
  }

  // Orden
  var mOrd = String(params||'').match(/[?&]order=([^&]+)/);
  if(mOrd){
    var partes = decodeURIComponent(mOrd[1]).split('.');
    var campo = partes[0], desc = partes.indexOf('desc') >= 0;
    filas = filas.slice().sort(function(a,b){
      var x=a[campo], y=b[campo];
      var n = (typeof x==='number' && typeof y==='number')
        ? x-y : String(x==null?'':x).localeCompare(String(y==null?'':y));
      return desc ? -n : n;
    });
  }

  // Paginación
  var mOff = String(params||'').match(/[?&]offset=(\d+)/);
  var mLim = String(params||'').match(/[?&]limit=(\d+)/);
  var desde = mOff ? +mOff[1] : 0;
  var hasta = mLim ? desde + (+mLim[1]) : undefined;
  return filas.slice(desde, hasta);
}

// El chat en vivo intenta abrir un socket cada pocos segundos y llena la
// consola de errores. Sin red no tiene sentido: se apaga mientras dure.
window.addEventListener('offline', function(){
  try{ if(typeof chatDesconectar==='function') chatDesconectar(); }catch(e){}
});


/* ============================================================================
   inv_buscar SIN CONEXION
   ---------------------------------------------------------------------------
   Devuelve lo mismo que el RPC del servidor, con los datos descargados. Asi
   el catalogo no necesita un camino aparte: ordena, pagina y pinta igual.

   No todos los filtros se pueden aplicar —los que dependen de tablas que no
   se descargan— pero los que se usan a diario si: texto, departamento, marca,
   precio, stock y bultos.
============================================================================ */
var _KCC_ART = null;      // catalogo en memoria, se carga una vez

async function _kccCatalogo(){
  if(_KCC_ART) return _KCC_ART;
  var meta = await kccLeer('art:meta');
  if(!meta || !meta.v) return null;
  var out = [];
  for(var b=0; b<meta.v.bloques; b++){
    var blo = await kccLeer('art:'+b);
    if(blo && blo.v) out = out.concat(blo.v);
  }
  _KCC_ART = out;
  return out;
}

function _kccTexto(a){
  return (String(a.itemname||'') + ' ' + String(a.itemcode||'') + ' '
        + String(a.marca||'') + ' ' + String(a.codebars||'')).toUpperCase();
}

async function kccInvBuscar(body){
  var art = await _kccCatalogo();
  if(!art) return null;                 // sin catalogo descargado
  var r = art;

  // Coleccion o marca: llegan como lista de itemcodes
  if(body.p_itemcodes && body.p_itemcodes.length){
    var set = {};
    body.p_itemcodes.forEach(function(c){ set[String(c).replace(/^"|"$/g,'')] = 1; });
    r = r.filter(function(a){ return set[String(a.itemcode)]; });
  }

  // Busqueda por texto: todas las palabras deben aparecer
  var textos = body.p_textos && body.p_textos.length ? body.p_textos
             : (body.p_q ? [body.p_q] : null);
  if(textos){
    var grupos = textos.map(function(t){
      return String(t).toUpperCase().split(/\s+/).filter(Boolean);
    });
    r = r.filter(function(a){
      var s = _kccTexto(a);
      // Basta con que cumpla UNO de los textos (se combinan con O, como en
      // el servidor), pero dentro de cada uno todas sus palabras.
      for(var g=0; g<grupos.length; g++){
        var todas = true;
        for(var p=0; p<grupos[g].length; p++){
          if(s.indexOf(grupos[g][p]) < 0){ todas = false; break; }
        }
        if(todas) return true;
      }
      return false;
    });
  }

  if(body.p_grupo)  r = r.filter(function(a){ return String(a.grupo||'')===body.p_grupo; });
  if(body.p_grupos && body.p_grupos.length){
    var gs={}; body.p_grupos.forEach(function(g){ gs[String(g)]=1; });
    r = r.filter(function(a){ return gs[String(a.grupo||'')]; });
  }
  if(body.p_subg && body.p_subg.length){
    var sg={}; body.p_subg.forEach(function(x){ sg[String(x)]=1; });
    r = r.filter(function(a){ return sg[String(a.subg||'')]; });
  }

  if(body.p_pmin!=null) r = r.filter(function(a){ return (Number(a.precioventa)||0) >= body.p_pmin; });
  if(body.p_pmax!=null) r = r.filter(function(a){ return (Number(a.precioventa)||0) <= body.p_pmax; });
  if(body.p_smin!=null) r = r.filter(function(a){ return (Number(a.disponible)||0) >= body.p_smin; });

  if(body.p_bmin!=null || body.p_bmax!=null){
    r = r.filter(function(a){
      var ub = Math.max(1, Number(a.unidadesbulto)||1);
      var b = Math.floor((Number(a.disponible)||0) / ub);
      if(body.p_bmin!=null && b < body.p_bmin) return false;
      if(body.p_bmax!=null && b > body.p_bmax) return false;
      return true;
    });
  }

  if(body.p_disp==='stock')   r = r.filter(function(a){ return (Number(a.disponible)||0) > 0; });
  if(body.p_disp==='agotado') r = r.filter(function(a){ return (Number(a.disponible)||0) <= 0; });

  // Rango de entrada y "mercancia reciente": el portal los manda como fechas.
  if(body.p_desde) r = r.filter(function(a){ return String(a.fechaentrada||'') >= body.p_desde; });
  if(body.p_hasta) r = r.filter(function(a){ return String(a.fechaentrada||'') <= body.p_hasta; });

  // Bajo stock: menos de un bulto pero con algo.
  if(body.p_bajo){
    r = r.filter(function(a){
      var d = Number(a.disponible)||0, ub = Math.max(1, Number(a.unidadesbulto)||1);
      return d > 0 && d < ub;
    });
  }

  if(body.p_tipo) r = r.filter(function(a){ return String(a.tipo||'')===body.p_tipo; });
  if(body.p_anio) r = r.filter(function(a){
    return String(a.fechaentrada||'').substring(0,4) === String(body.p_anio);
  });

  if(body.p_confoto===true)  r = r.filter(function(a){ return !!(a.picturname||a.foto_url); });
  if(body.p_confoto===false) r = r.filter(function(a){ return !(a.picturname||a.foto_url); });

  // Orden: EXACTAMENTE las mismas opciones que en linea, para que la lista se
  // vea igual con o sin conexion. El defecto es 'reciente', como el servidor.
  var _txt = function(x){ return String(x==null?'':x); };
  var cmp = {
    'precio_asc'  : function(a,b){ return (Number(a.precioventa)||0)-(Number(b.precioventa)||0); },
    'precio_desc' : function(a,b){ return (Number(b.precioventa)||0)-(Number(a.precioventa)||0); },
    'stock_desc'  : function(a,b){ return (Number(b.disponible)||0)-(Number(a.disponible)||0); },
    'stock_asc'   : function(a,b){ return (Number(a.disponible)||0)-(Number(b.disponible)||0); },
    'nombre'      : function(a,b){ return _txt(a.itemname).localeCompare(_txt(b.itemname)); },
    'sku'         : function(a,b){ return _txt(a.itemcode).localeCompare(_txt(b.itemcode)); },
    'reciente'    : function(a,b){
        var d = _txt(b.fechaentrada).localeCompare(_txt(a.fechaentrada));
        return d !== 0 ? d : _txt(a.itemname).localeCompare(_txt(b.itemname));
      }
  }[String(body.p_orden || 'reciente')] || function(a,b){
    return _txt(b.fechaentrada).localeCompare(_txt(a.fechaentrada));
  };
  r = r.slice().sort(cmp);

  var off = Number(body.p_offset)||0;
  var lim = Number(body.p_limit)||60;
  return r.slice(off, off+lim);
}

// Al descargar datos nuevos, se descarta el catalogo en memoria.
var _kccDescargarTodoOrig = kccDescargarTodo;
kccDescargarTodo = async function(onProg){
  var r = await _kccDescargarTodoOrig(onProg);
  _KCC_ART = null;
  return r;
};


/* ── Fotos guardadas en el catálogo ────────────────────────────────────────
   fotoPair() se llama al pintar cada tarjeta y tiene que devolver una URL al
   instante, pero leer de IndexedDB es asincrono. Se cargan todas las
   miniaturas en memoria una vez y se sirven desde ahi.
   36.000 objectURL son punteros, no imagenes: apenas ocupan.               */
// Solo se guarda en memoria QUE codigos tienen foto (un Set de textos, ~1 MB), no las
// fotos en si. Cargar las 30.000 imagenes de golpe congelaba el iPad varios segundos y
// se quedaba con todas en memoria; ahora cada objectURL se crea cuando la foto se va a
// ver de verdad, y solo se mantienen las ultimas 300.
var _KCC_FOTO_SET = null;        // Set de itemcodes con foto guardada
var _KCC_FOTO_URL = {};          // itemcode -> objectURL, creado bajo demanda
var _KCC_FOTO_ORDEN = [];        // para soltar los mas viejos
var KCC_FOTO_MAX_MEM = 300;

async function kccCargarIndiceFotos(){
  if(_KCC_FOTO_SET) return _KCC_FOTO_SET;
  var db = await kccAbrirDB();
  var set = new Set();
  await new Promise(function(res){
    var t = db.transaction('datos','readonly');
    // getAllKeys, no openCursor: no hace falta leer el VALOR de cada registro, y el
    // almacen tambien tiene los bloques del catalogo (27 MB) y el historial.
    var q2 = t.objectStore('datos').getAllKeys();
    q2.onsuccess = function(){
      (q2.result||[]).forEach(function(k){
        var s2 = String(k||'');
        if(s2.indexOf('foto:')===0) set.add(s2.slice(5));
      });
      res();
    };
    q2.onerror = function(){ res(); };
  });
  _KCC_FOTO_SET = set;
  console.log('[offline] fotos guardadas:', set.size);
  return set;
}

// Crea (o reutiliza) el objectURL de una foto. Suelta los mas antiguos para no
// acumular miles de blobs abiertos.
async function kccFotoURL(code){
  var c = String(code);
  if(_KCC_FOTO_URL[c]) return _KCC_FOTO_URL[c];
  if(_KCC_FOTO_SET && !_KCC_FOTO_SET.has(c)) return null;
  var r = await kccLeer('foto:'+c);
  if(!r || !r.v) return null;
  var u;
  try{ u = (typeof r.v === 'string') ? r.v : URL.createObjectURL(r.v); }catch(e){ return null; }
  _KCC_FOTO_URL[c] = u;
  _KCC_FOTO_ORDEN.push(c);
  while(_KCC_FOTO_ORDEN.length > KCC_FOTO_MAX_MEM){
    var viejo = _KCC_FOTO_ORDEN.shift();
    var vu = _KCC_FOTO_URL[viejo];
    if(vu && vu.indexOf('blob:')===0){ try{ URL.revokeObjectURL(vu); }catch(e){} }
    delete _KCC_FOTO_URL[viejo];
  }
  return u;
}

// Compatibilidad con lo que ya llamaba a esta funcion.
async function kccFotoDe(code){ return kccFotoURL(code); }

// Sustituye fotoPair. Sin conexion devuelve la miniatura SI ya esta en memoria; si no,
// devuelve vacio y la coloca en cuanto se lee del disco (kccPintarFotos).
function kccEngancharFotos(){
  if(typeof fotoPair !== 'function' || window._KCC_FOTOPAIR) return;
  window._KCC_FOTOPAIR = fotoPair;
  window.fotoPair = function(picturname, foto_url, itemcode){
    if(!navigator.onLine){
      var k = itemcode || String(picturname||'').replace(/\.[^.]+$/,'');
      var u = _KCC_FOTO_URL[k];
      if(u) return {primary:u, fb:''};
      // Sin conexion no se devuelve la URL del servidor: solo llenaria la consola de
      // errores. Se deja vacia; kccPintarFotos la rellena si esta guardada.
      return {primary:'', fb:''};
    }
    return window._KCC_FOTOPAIR(picturname, foto_url);
  };
}

// Rellena las fotos de lo que YA esta en pantalla. Se llama despues de pintar, y solo
// toca las imagenes visibles: da igual que haya 30.000 guardadas.
async function kccPintarFotos(contenedor){
  if(navigator.onLine) return;
  await kccCargarIndiceFotos();
  var raiz = contenedor || document;
  var tarjetas = raiz.querySelectorAll('[data-code],[data-pcode],[id^="pcard-"]');
  for(var i=0; i<tarjetas.length; i++){
    var card = tarjetas[i];
    var code = card.getAttribute('data-code') || card.getAttribute('data-pcode')
             || String(card.id||'').replace(/^pcard-/,'');
    if(!code) continue;
    var img = card.querySelector('img');
    if(!img || (img.src && img.src.indexOf('blob:')===0)) continue;
    var u = await kccFotoURL(code);
    if(!u) continue;
    img.src = u;
    img.style.display = '';
    img.removeAttribute('onerror');
  }
}

document.addEventListener('DOMContentLoaded', function(){
  setTimeout(function(){
    kccEngancharFotos();
    // Solo el indice (que codigos tienen foto), no las fotos: es instantaneo.
    kccCargarIndiceFotos().catch(function(){});
  }, 2000);
});


/* ============================================================================
   HISTORIAL SIN CONEXION — ultimos 24 meses
   ---------------------------------------------------------------------------
   Facturas, pedidos, estado de cuenta, mercancia por llegar y devoluciones.

   Se guardan AGRUPADAS POR CLIENTE, no en bloques sueltos: casi todo lo que
   se consulta es "lo de este cliente", y asi se lee un solo registro en vez
   de recorrer un millon de filas. Es la diferencia entre responder al
   instante o tardar varios segundos.
============================================================================ */

var KCC_MESES_HIST = 24;

function _kccDesde(){
  var d = new Date();
  d.setMonth(d.getMonth() - KCC_MESES_HIST);
  // Local, no UTC: si no, el corte de los 24 meses se desplaza un dia.
  return new Date(d.getTime() - d.getTimezoneOffset()*60000)
           .toISOString().slice(0,10);
}

// Trae una tabla por paginas, llamando a onLote segun llegan para no
// acumularlo todo en memoria antes de guardar.
async function _kccBajarTabla(tabla, select, filtroFecha, onProg){
  var PAG = 1000, desde = 0, todo = [];
  var desdeF = _kccDesde();
  while(!KCC_PRE.cancelar){
    var f = select + '&' + filtroFecha + '=gte.' + desdeF
          + '&order=' + filtroFecha + '.desc&limit=' + PAG + '&offset=' + desde;
    var r;
    try{ r = await q(tabla, f); }catch(e){ break; }
    if(!r || !r.length) break;
    todo = todo.concat(r);
    desde += r.length;
    if(onProg) onProg(todo.length);
    if(r.length < PAG) break;
  }
  return todo;
}

// Agrupa por cliente y guarda un registro por cada uno.
async function _kccGuardarPorCliente(prefijo, filas, campoCliente){
  var porCli = {};
  filas.forEach(function(x){
    var c = String(x[campoCliente] || '');
    if(!c) return;
    (porCli[c] = porCli[c] || []).push(x);
  });
  var codes = Object.keys(porCli);
  for(var i=0; i<codes.length; i++){
    await kccGuardar(prefijo + ':' + codes[i], porCli[codes[i]]);
  }
  await kccGuardar(prefijo + ':meta', {n:filas.length, clientes:codes.length, fecha:Date.now()});
  return codes.length;
}

async function kccDescargarHistorial(onProg){
  if(KCC_PRE.activa) return;
  KCC_PRE.activa = true; KCC_PRE.cancelar = false;

  function prog(fase, n){ if(onProg) onProg(fase, n); }

  try{
    // ── Facturas ──────────────────────────────────────────────────────────
    prog('facturas', 0);
    var fac = await _kccBajarTabla('facturas',
      'select=docnum,docdate,docduedate,cardcode,cardname,doctotal,paidtodate,docstatus,'
      + 'itemcode,dscription,quantity,price,linetotal,linenum,slpcode,nombrevendedor',
      'docdate', function(n){ prog('facturas', n); });
    if(KCC_PRE.cancelar) throw new Error('cancelado');
    await _kccGuardarPorCliente('fac', fac, 'cardcode');

    // Indice por ARTICULO: lo usa el restock y el ultimo precio pagado.
    var porArt = {};
    fac.forEach(function(x){
      var k = String(x.itemcode||''); if(!k) return;
      (porArt[k] = porArt[k] || []).push({
        c:x.cardcode, d:x.docdate, q:x.quantity, p:x.price, n:x.docnum
      });
    });
    var arts = Object.keys(porArt);
    for(var i=0; i<arts.length; i++) await kccGuardar('facart:'+arts[i], porArt[arts[i]]);
    await kccGuardar('facart:meta', {n:arts.length, fecha:Date.now()});
    fac = null; porArt = null;          // liberar memoria antes de seguir

    // ── Pedidos ───────────────────────────────────────────────────────────
    prog('pedidos', 0);
    var ped = await _kccBajarTabla('pedidos',
      'select=docnum,docdate,docduedate,cardcode,cardname,doctotal,docstatus,confirmed,'
      + 'itemcode,dscription,quantity,price,openqty,linenum,slpcode,nombrevendedor,comments',
      'docdate', function(n){ prog('pedidos', n); });
    if(KCC_PRE.cancelar) throw new Error('cancelado');
    await _kccGuardarPorCliente('ped', ped, 'cardcode');
    ped = null;

    // ── Estado de cuenta ──────────────────────────────────────────────────
    prog('estado', 0);
    var ec = await _kccBajarTabla('movimientos',
      'select=cardcode,docdate,docduedate,tipo,docnum,debito,credito,comments',
      'docdate', function(n){ prog('estado', n); });
    if(KCC_PRE.cancelar) throw new Error('cancelado');
    await _kccGuardarPorCliente('mov', ec, 'cardcode');
    ec = null;

    // ── Mercancia por llegar ──────────────────────────────────────────────
    // Sin filtro de cliente: es de la empresa, no de nadie en concreto.
    prog('porllegar', 0);
    var pll = [];
    try{
      pll = await qAll('opor_lineas',
        'select=itemcode,dscription,quantity,openqty,price,docnum,docdate,shipdate&openqty=gt.0');
    }catch(e){}
    for(var b=0; b<pll.length; b+=2000){
      await kccGuardar('pll:'+Math.floor(b/2000), pll.slice(b, b+2000));
    }
    await kccGuardar('pll:meta', {n:pll.length, bloques:Math.ceil(pll.length/2000), fecha:Date.now()});
    prog('porllegar', pll.length);

    // ── Devoluciones ──────────────────────────────────────────────────────
    prog('devoluciones', 0);
    var dev = [];
    try{
      dev = await _kccBajarTabla('devoluciones', 'select=*', 'docdate',
        function(n){ prog('devoluciones', n); });
    }catch(e){}
    if(dev.length) await _kccGuardarPorCliente('dev', dev, 'cardcode');

    await kccGuardar('hist:meta', {fecha:Date.now(), meses:KCC_MESES_HIST});
    prog('listo', 0);
    return true;

  } finally { KCC_PRE.activa = false; }
}

async function kccEstadoHistorial(){
  var m = await kccLeer('hist:meta');
  var f = await kccLeer('fac:meta');
  var p = await kccLeer('ped:meta');
  var v = await kccLeer('mov:meta');
  return {
    hay: !!(m && m.v),
    fecha: m && m.v ? m.v.fecha : null,
    facturas: f && f.v ? f.v.n : 0,
    pedidos:  p && p.v ? p.v.n : 0,
    movimientos: v && v.v ? v.v.n : 0
  };
}


/* ============================================================================
   TARJETA DE ESTADO EN EL DASHBOARD
   ---------------------------------------------------------------------------
   Se ve de entrada, sin buscar un boton: que hay descargado, de cuando, cuanto
   ocupa y si quedan pedidos por enviar. Con un boton para descargar o poner al
   dia, y otro para liberar espacio.
============================================================================ */

function _kccHace(iso){
  if(!iso) return 'nunca';
  var s = (Date.now() - new Date(iso).getTime())/1000;
  if(s < 60)    return 'hace un momento';
  if(s < 3600)  return 'hace ' + Math.round(s/60) + ' min';
  if(s < 86400) return 'hace ' + Math.round(s/3600) + ' h';
  var d = Math.round(s/86400);
  return 'hace ' + d + ' d\u00eda' + (d===1?'':'s');
}

function _kccMB(b){
  b = Number(b)||0;
  return b >= 1048576 ? (b/1048576).toFixed(0) + ' MB' : (b/1024).toFixed(0) + ' KB';
}

async function _kccEspacio(){
  try{
    if(navigator.storage && navigator.storage.estimate){
      var e = await navigator.storage.estimate();
      return e.usage || 0;
    }
  }catch(e){}
  return 0;
}

async function kccPintarTarjeta(){
  // Solo para el personal interno: un cliente no descarga catalogos.
  if(!CU || CU.rol==='cliente') return;
  var dash = document.getElementById('page-dashboard');
  if(!dash) return;

  var est   = await kccEstadoPrecarga();
  var hist  = await kccEstadoHistorial();
  var fotos = (await kccCargarIndiceFotos()).size;
  var pend  = (await kccPedidosEnCola()).length;
  var uso   = await _kccEspacio();
  var hay   = est.articulos > 0;

  var t = document.getElementById('kcc-tarjeta');
  if(!t){
    t = document.createElement('div');
    t.id = 'kcc-tarjeta';
    t.className = 'card';
    t.style.cssText = 'margin-bottom:12px;border:1px solid rgba(0,159,227,.35);background:rgba(0,159,227,.07)';
    dash.insertBefore(t, dash.firstChild);
  }

  var det = [];
  if(hay) det.push(fmtN(est.articulos) + ' art\u00edculos');
  if(est.clientes)   det.push(fmtN(est.clientes) + ' clientes');
  if(hist.facturas)  det.push(fmtN(hist.facturas) + ' l\u00edn. factura');
  if(fotos)          det.push(fmtN(fotos) + ' fotos');

  t.innerHTML =
     '<div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:200px">'
        +'<div style="font-size:13.5px;font-weight:700">\u{1F4E5} Trabajar sin internet \u00b7 '
        + (hay ? '<span style="color:var(--green)">listo</span>'
               : '<span style="color:var(--amber)">sin descargar</span>') + '</div>'
        +'<div style="font-size:12px;color:var(--text3);margin-top:3px;line-height:1.5">'
        + (hay ? (det.join(' \u00b7 ') + ' \u00b7 ' + _kccHace(est.fecha))
               : 'Descarga el cat\u00e1logo y los clientes para poder pedir sin se\u00f1al.')
        + (uso ? (' \u00b7 \u{1F4BE} ' + _kccMB(uso)) : '')
        + (pend ? ('<br><span style="color:var(--amber);font-weight:600">\u23F3 '
                   + pend + ' pedido(s) por enviar</span>') : '')
        +'</div>'
      +'</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap">'
        +'<button class="btn btn-sm btn-p" onclick="kccAbrirPrecarga()">'
        + (hay ? 'Poner al d\u00eda' : 'Descargar') + '</button>'
        + (hay ? '<button class="btn btn-sm" onclick="kccBorrarTodo()">Liberar espacio</button>' : '')
      +'</div>'
    +'</div>';
}

async function kccBorrarTodo(){
  if(!confirm('\u00bfBorrar el cat\u00e1logo, los clientes, el historial y las fotos guardados '
    + 'en este dispositivo?\\n\\nPodr\u00e1s volver a descargarlos con internet. '
    + 'Los pedidos en cola NO se borran.')) return;
  try{
    var db = await kccAbrirDB();
    var claves = await new Promise(function(res){
      var q2 = db.transaction('datos','readonly').objectStore('datos').getAllKeys();
      q2.onsuccess = function(){ res(q2.result||[]); };
      q2.onerror   = function(){ res([]); };
    });
    var t = db.transaction('datos','readwrite');
    var st = t.objectStore('datos');
    claves.forEach(function(k){ st.delete(k); });
    await new Promise(function(res){ t.oncomplete = res; t.onerror = res; });

    // Soltar los objectURL abiertos para que el navegador libere de verdad.
    Object.keys(_KCC_FOTO_URL).forEach(function(k){
      var u = _KCC_FOTO_URL[k];
      if(u && u.indexOf('blob:')===0){ try{ URL.revokeObjectURL(u); }catch(e){} }
    });
    _KCC_FOTO_URL = {}; _KCC_FOTO_ORDEN = []; _KCC_FOTO_SET = null; _KCC_ART = null;

    kccAviso('Descarga borrada \u00b7 espacio liberado', 'gris');
    kccPintarTarjeta();
  }catch(e){ kccAviso('No se pudo borrar: ' + (e.message||e), 'red'); }
}

// La tarjeta se pinta al entrar al dashboard y al terminar cualquier descarga.
document.addEventListener('DOMContentLoaded', function(){
  setTimeout(function(){ try{ kccPintarTarjeta(); }catch(e){} }, 2500);
});


/* ── Un solo mensaje, sin tecnicismos ─────────────────────────────────────
   Sin conexion el usuario no tiene que leer "Failed to fetch" ni el nombre de
   la base de datos: eso es cosa nuestra. Solo necesita saber que no hay red y
   que puede seguir trabajando.                                            */
function _sinConexionAviso(el, texto){
  if(!el) return;
  el.innerHTML =
     '<div style="grid-column:1/-1;padding:34px 20px;text-align:center;color:var(--text3);line-height:1.6">'
    +'<div style="font-size:30px;margin-bottom:8px">\u{1F4F4}</div>'
    +'<div style="font-size:14px;font-weight:600;color:var(--text)">Sin conexi\u00f3n</div>'
    +'<div style="font-size:12.5px;margin-top:5px">'
    + (texto || 'Esta pantalla necesita internet. Puedes seguir armando pedidos '
              + 'con el cat\u00e1logo descargado.')
    +'</div></div>';
}
window._sinConexionAviso = _sinConexionAviso;
